import { httpClient } from "./httpClient";
import { getAuthHeaders } from "./authHeaders";
import { normalizeApiError } from "./normalizeApiError";
import { notifyAccountContextInvalid } from "../../shared/lib/auth/accountContext";

const accountContextErrorCodes = new Set([
  "account_selection_required",
  "account_access_revoked",
]);

export async function apiRequest({
  method,
  path,
  data,
  params,
  headers,
  baseURL,
  responseType,
  onDownloadProgress,
  auth = true,
  includeAccountContext,
  authorizationToken,
  errorMessage,
}) {
  try {
    const authHeaders = auth
      ? await getAuthHeaders({
          includeAccountContext: includeAccountContext ?? false,
          authorizationToken,
        })
      : {};
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const contentHeaders = isFormData ? {} : { "Content-Type": "application/json" };

    const response = await httpClient.request({
      method,
      url: path,
      baseURL,
      data,
      params,
      responseType,
      onDownloadProgress,
      headers: {
        ...contentHeaders,
        ...authHeaders,
        ...headers,
      },
    });

    return response.data;
  } catch (error) {
    const normalizedError = normalizeApiError(error, errorMessage);

    if (auth && accountContextErrorCodes.has(normalizedError?.error)) {
      notifyAccountContextInvalid(normalizedError);
    }

    throw normalizedError;
  }
}
